import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import PageHome from './pages/Home';
import PageMembers from './pages/Members';
import PageConcerts from './pages/Concerts';
import PageGallery from './pages/Gallery';
import PageContatti from './pages/Contacts';
import PageCookies from './pages/Cookies';
import PageNotFound from './pages/NotFound';
import TopNavBar from './components/TopNavBar';
import FullImageBg from './components/FullImageBg';
import Footer from './components/Footer';
import groupinfo from './data/groupinfo.json';
import CookieBanner from 'react-cookie-banner';
//import WOW from 'wowjs';
import './App.css';
import './css/common.css';

class App extends Component {
  render() {
    const isHomePage = window.location.pathname === '/';
    return (
      <div className="App">

        <CookieBanner
          // styles={styles}
          message="Questo sito fa uso di cookie. Proseguendo la navigazione acconsenti all'uso di tutti i cookie."
          link={{
            msg: 'Se vuoi saperne di più clicca qui',
            url: '/cookies'
          }}
          buttonMessage='CHIUDI'
          dismissOnScroll={true}
          onAccept={() => { }}
          cookie="user-has-accepted-cookies"
          className="cookiesbanner" 
        // onAccept={() => setState({ accepted: true })}
        />
        <header className={isHomePage ? 'fh-header' : ''}>
          <TopNavBar navbarcssclass={''} />
          {isHomePage && <FullImageBg />}
        </header>
        <main>
          <Switch>
            <Route exact path="/" component={PageHome} />
            <Route path="/componenti" render={() => <PageMembers />} />
            <Route path="/concerti" component={PageConcerts} />
            <Route path="/gallery" component={PageGallery} />
            <Route path="/contatti" component={PageContatti} />
            <Route path="/cookies" component={PageCookies} />
            <Route component={PageNotFound} />
          </Switch>
        </main>
        <Footer groupinfo={groupinfo} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js